export default __webpack_public_path__ + "static/media/55_Random_Flip.d6f3be92.mp4";